<template>
  <div class="grid-container">
    <h1 class="mb-3 column-one">{{ $t('message.credit.application.socialSecurity.title') }}</h1>
    <p class="mb-4 column-one">{{ $t('message.credit.application.socialSecurity.subTitle') }}</p>
    <mobialis-form-with-validation @onValidate="emitValidation" class="d-contents">
      <mobialis-text-input-with-validation
        :rules="{ required: isCreditSSNRequired, min: 9, max: 9, regex: ssnRegex }"
        :label="ssnInputText"
        v-model="ssn"
        mask-type="socialSecurityNumber"
        vid="socialSecurity"
        data-cy="socialSecurity"
        class="column-one max-input"
      ></mobialis-text-input-with-validation>
      <DisclaimerCard
        class="card column-two border-0 shadow mb-4"
        :iconSrc="require('@/assets/eye.svg')"
        :title="$t('message.credit.valuePrivacyTitle')"
        :text="disclaimerText"
        :text-left-space="false"
      ></DisclaimerCard>
      <div class="card column-one primary-light-blue border-0 mt-3">
        <div class="card-body p-3" v-html="termsText"></div>
      </div>
      <mobialis-button type="submit" class="my-4 column-three" data-cy="submitSocialSecurity">{{
        $t('message.common.continue')
      }}</mobialis-button>
    </mobialis-form-with-validation>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { provinceMixin, stateMixin } from '@/mixins';
import DisclaimerCard from '@/components/DisclaimerCard.vue';
import { privateStoreInstance } from '@/store';

export default {
  name: 'SocialSecurityNumber',
  mixins: [provinceMixin, stateMixin],
  data() {
    return {
      ssn: '',
      ssnRegex: /^(?!666|000|9\d{2})\d{3}-?(?!00)\d{2}-?(?!0{4})\d{4}$/,
    };
  },
  components: {
    DisclaimerCard,
  },
  computed: {
    ...mapGetters('business', ['getThisIsAmerica', 'isCreditSSNRequired']),
    termsText() {
      return this.$t('message.credit.application.socialSecurity.privacyInfo', {
        link: this.$t('message.credit.form1Link'),
      });
    },
    ssnInputText() {
      if (this.isCreditSSNRequired) {
        return this.$t('message.credit.application.socialSecurity.inputLabel');
      }
      return `${this.$t('message.credit.application.socialSecurity.inputLabel')} ${this.$t(
        'message.credit.application.socialSecurity.optional'
      )}`;
    },
    disclaimerText() {
      if (this.isCreditSSNRequired) {
        return this.$t('message.credit.disclaimer.socialSecurity.SSNText');
      }
      return `${this.$t('message.credit.disclaimer.socialSecurity.optionalSSNText1')} <br><br> ${this.$t(
        'message.credit.disclaimer.socialSecurity.optionalSSNText2'
      )}`;
    },
  },
  methods: {
    emitValidation(isValid) {
      if (!isValid) {
        // eslint-disable-next-line
        return;
      }
      try {
        // Only try to update the SSN if it is set, it may or may not be required
        if (this.ssn) {
          privateStoreInstance.commit('SET_SOCIAL_SECURITY_NUMBER', this.ssn);
        }
      } catch (err) {
        this.$log('Error updating private store - SSN', err);
      } finally {
        this.$router.push({ name: `finance-application-${this.baseRoute}` });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'src/assets/scss/variables';

.d-contents {
  display: contents;
}
.grid-container {
  display: grid;
  grid-template-columns: 1fr 30%;
  grid-gap: 0 10%;
}
.column-one {
  grid-column: 1/2;
}
.column-two {
  grid-column: 2/3;
  grid-row: 1/5;
}
.column-three {
  grid-column: 1/3;
}
.max-input {
  max-width: 317px;
}
.primary-light-blue {
  background-color: $primary-light-blue;
}

/* Mobile only*/
@media only screen and (max-width: $breakpoint-mobile) {
  .grid-container {
    display: unset;

    .d-contents {
      display: unset;
    }
  }
}
</style>
